import type { Variants } from 'motion/react';

/** Soft fade-in-up — for sections, paragraphs, cards. */
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.2, 0.8, 0.2, 1] },
  },
};

/** Stagger container — wrap N children and they cascade in. */
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

/** Scale-in for cards / images. */
export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.5, ease: [0.2, 0.8, 0.2, 1] },
  },
};

/** Page-level transition. Use as motion.div variants. */
export const pageTransition: Variants = {
  initial: { opacity: 0, y: 8 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: [0.2, 0.8, 0.2, 1] },
  },
  exit: { opacity: 0, transition: { duration: 0.2 } },
};

/** Letter-reveal — line-by-line hero text. Apply to each h1 line in an overflow-hidden mask. */
export const letterReveal: Variants = {
  hidden: { y: '110%' },
  visible: {
    y: 0,
    transition: { duration: 0.9, ease: [0.2, 0.8, 0.2, 1] },
  },
};

/** Viewport options we reuse — fire once, slightly before the element enters. */
export const inViewOnce = {
  once: true,
  margin: '-80px',
} as const;
